import { Box, Button, Card, Container, InputBase, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Dialog, DialogTitle, DialogContent, TextField, DialogActions, MenuItem, Popover, Select, TableHead, CircularProgress, DialogContentText, FormControl, InputLabel, OutlinedInput, Chip, Grid } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { file_URL } from '../../utils/url'

function SocialMediaSelfAssigned() {

    const [open, setOpen] = useState(null)
    const [formOpen, setFormOpen] = useState(false);
    const UserId = sessionStorage.getItem("userId");
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType")
    const [assignedLeads, setAssignedLeads] = useState([]);
    const [dailyData, setDailyData] = useState("")
    const [view, setView] = useState([]);
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [selectedLead, setSelectedLead] = useState("");
    const [allUpdates, setAllUpdates] = useState([]);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({})
    const [fileUpload, setFileUpload] = useState(null);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [events, setEvents] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [contentCreationData, setContentCreationData] = useState([])

    const [formData, setFormData] = useState({
        platform: '',
        postType: '',
        contentTopic: '',
        postCaption: '',
        hashtagsUsed: [],
        postedBy: "",
        postStatus: "",
        comments: "",
        scheduledDateTime: '',
        deadline: '',
        status: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        let lead;
        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task);
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setFormOpen(false)
    }

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            const filteredUsers = response.data.results.filter(user =>
                user.serviceTeamType && user.serviceTeamType.includes("Social Media")
            );

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    };

    const getDailyUpdates = async () => {

        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Social Media Team:", err);
            toast.error(`Failed to load Social Media Team. ${err ? err : ''}`);
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Social Media");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData); // Store all data here
            // setView(filteredData);

        } catch (err) {
            console.error("Error while fetching Social Media Team:", err);
            toast.error(`Failed to load Social Media Team. ${err ? err : ''}`);
        }

    }

    const getAllLeads = async (skip = currentPage, limit = 5) => {
        const parmas = {
            page: skip,
            limit: limit
        }
        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData(`leads/leads/${UserId}`, parmas, sessionToken);
            console.log("Response:", response)

            const responseData = response?.data[0]?.paginatedResults || [];

            setContentCreationData(responseData)
            setTotalPages(response.data[0].totalPages);
            setTotalCount(response.data[0].totalCount.totalItems);

        }
        catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!", response?.message);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error(`Error uploading file. ${error ? error : ''}`);
        }
    };

    const postDailyUpdates = async () => {
        debugger
        try {

            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.socialMediaHistory?.map(history => history?.dailyUpdateId));

            const socialMediaHistory = selectedLead?.socialMediaHistory?.[0] ||
                selectedLead?.socialMediaHistory ||
                {};
            const assignedPosts = selectedLead?.socialMediaHistory?.[0]?.assignedPosts;
            const previousCompleted = socialMediaHistory.completedPosts;
            const newCompleted = parseInt(formData.completedPosts, 10);
            const totalCompleted = previousCompleted + newCompleted;
            const remainingShots = assignedPosts - newCompleted;

            const deadline = selectedLead?.socialMediaHistory?.[0]?.deadline ||
                selectedLead?.socialMediaHistory?.deadline ||
                '';
            const totalPosts = selectedLead?.socialMediaHistory?.[0]?.totalPosts ||
                selectedLead?.socialMediaHistory?.totalPosts ||
                '';
            const monthlyPosts = selectedLead?.socialMediaHistory?.[0]?.monthlyPosts ||
                selectedLead?.socialMediaHistory?.monthlyPosts ||
                '';
            const platform = selectedLead?.socialMediaHistory?.[0]?.platform ||
                selectedLead?.socialMediaHistory?.platform ||
                '';
            const postType = selectedLead?.socialMediaHistory?.[0]?.postType ||
                selectedLead?.socialMediaHistory?.postType ||
                '';

            const amount = selectedLead?.socialMediaHistory?.[0]?.amount ||
                selectedLead?.socialMediaHistory?.amount ||
                '';
            const assignedTo = selectedLead?.socialMediaHistory?.[0]?.assignedTo ||
                selectedLead?.socialMediaHistory?.assignedTo ||
                '';
            const status = selectedLead?.socialMediaHistory?.[0]?.completedPosts === selectedLead?.socialMediaHistory?.[0]?.totalPosts ? "Completed" : "Pending";

            const payLoad = {
                leadId: selectedLeadId,
                amount,
                monthlyPosts,
                assignedTo,
                platform: platform,
                postType: postType,
                postStatus: status,
                comments: formData.comments,
                deadline: deadline,
                userId: UserId,
                serviceName: "Social Media",
                totalPosts,
                completedPosts: totalCompleted,
                assignedPosts: remainingShots
            }

            let response;

            if (existingUpdates.length === 0) {
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                const updateId = existingUpdates[existingUpdates.length - 1];
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                console.log("Response:", response);
                toast.success("Daily Work Updated Successfully!");
                setFormOpen(false);
                handleCloseDialog();
                getDailyUpdates();
                getAllLeads();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(`Something went wrong. Please try again! ${error ? error : ''}`);
        }

    }

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            getAllLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            getAllLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            getAllLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        getAllLeads(currentPage, limit);
        if (roleType === "Employee") {
            getDailyUpdates();
        }
    }, [role, roleType, serviceTeamType, currentPage, limit]);

    return (
        <>
            <Helmet>
                <title>Self Assigned | Social Media</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Self Assigned Tasks
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>
                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableCell>S.No</TableCell>
                                <TableCell>Lead</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Assigned Work</TableCell>
                                <TableCell>Deadline</TableCell>
                                <TableCell>Completed Tasks</TableCell>
                                {/* <TableCell>File</TableCell> */}
                                <TableCell>Status</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    contentCreationData.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={9} align="center">
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        contentCreationData?.map((task, id) => {
                                            return (
                                                <TableRow key={task?.id}>
                                                    <TableCell align="center">{calculateIndex(id)}</TableCell>
                                                    <TableCell align="center">{task?.name}</TableCell>
                                                    <TableCell align="center">{task?.phone}</TableCell>
                                                    <TableCell align="center">{task?.currentWork?.noOfPosters}</TableCell>
                                                    <TableCell align="center">{task?.currentWork !== null ? new Date(task?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                    <TableCell align="center">{task?.socialMediaHistory[0]?.completedPosts} / {task?.socialMediaHistory[0]?.totalPosts}</TableCell>
                                                    {/* <TableCell align="center">
                                                        <img
                                                            src={task?.socialMediaHistory[0]?.fileUpload?.path
                                                                ? `${file_URL+encodeURI(task?.socialMediaHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                : "#"}
                                                            alt='Image.png'
                                                            style={{ maxWidth: "50px", cursor: "pointer" }}
                                                            onClick={() => {
                                                                const fullImage = task?.socialMediaHistory[0]?.fileUpload?.path
                                                                    ? `${file_URL+encodeURI(task?.socialMediaHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                    : "#";
                                                                setSelectedImage(fullImage);
                                                                setOpenImage(true);
                                                            }}
                                                        />
                                                    </TableCell> */}
                                                    <TableCell align="center">
                                                        <Box position="relative" display="inline-flex">
                                                            <CircularProgress
                                                                variant="determinate"
                                                                value={task?.socialMediaHistory[0]?.progressPercentage}
                                                            />
                                                            <Box
                                                                top={0}
                                                                left={0}
                                                                bottom={0}
                                                                right={0}
                                                                position="absolute"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                            >
                                                                <Typography variant="caption" component="div" color="text.secondary">
                                                                    {typeof task?.socialMediaHistory[0]?.progressPercentage === 'number'
                                                                        ? `${Math.round(task.socialMediaHistory[0].progressPercentage)}%`
                                                                        : '0%'}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Iconify
                                                            icon="material-symbols-light:more-vert"
                                                            sx={{ margin: "auto" }}
                                                            onClick={(event) => handleOpenMenu(event, task, task._id, task?.socialMediaHistory[0]?.dailyUpdateId)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <PaginationComponent
                        name={"Leads"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                </Card>

                {/* Dialog for Adding Task */}
                <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
                    <DialogTitle>Daily Work Update!</DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            label="Completed Posts"
                            name="completedPosts"
                            value={formData.completedPosts}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField
                            margin="dense"
                            label="Comments"
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            fullWidth
                        />
                        {/* <TextField
                            select
                            margin="dense"
                            label="Post Status"
                            name="postStatus"
                            value={formData.postStatus}
                            onChange={handleChange}
                            fullWidth
                        >
                            {["Scheduled", "Posted", "Draft", "Pending Approval"].map((option) => (
                                <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                        </TextField> */}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary">Cancel</Button>
                        <Button color="primary" onClick={postDailyUpdates}>Update</Button>
                    </DialogActions>
                </Dialog>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    <MenuItem onClick={handleOpenDialog}>
                        <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                        View
                    </MenuItem>
                    <MenuItem onClick={handleOpen}>
                        <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                        Work Update
                    </MenuItem>
                </Popover>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div" // Ensure DialogContentText renders as a div to contain Box/Grid
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Post Type: {view?.socialMediaHistory[0]?.postType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.socialMediaHistory[0]?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id='paddingTop'>
                                                <Typography variant='body1'>
                                                    Content Topic: {view?.socialMediaHistory[0]?.contentTopic}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.socialMediaHistory?.status === 'Completed' ? 'success.main' :
                                                            view?.socialMediaHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.socialMediaHistory?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid> */}
                                            <Grid item xs={12} sm={6} id='paddingTop'>
                                                <Typography variant='body1'>
                                                    Platform: {view?.socialMediaHistory[0]?.platform.join(' , ')}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Shots: {view?.socialMediaHistory[0]?.completedPosts}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Shots: {view?.socialMediaHistory[0]?.totalPosts}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    No of Reels / Months: {view?.socialMediaHistory[0]?.monthlyPosts}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.socialMediaHistory[0]?.completionPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.socialMediaHistory[0]?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        "{view?.[0]?.socialMediaHistory[0]?.comments}"
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

            </Container>
        </>
    );
}

export default SocialMediaSelfAssigned;